function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

/* eslint-disable max-statements */
import { ConnectorName, RpcErrorCode } from '../constants';
import { ConnectorNotFoundError, ResourceUnavailableError, UserRejectedRequestError } from '../errors';
import { InjectedConnector } from './injected';

var _provider = /*#__PURE__*/new WeakMap();

export class MetaMaskConnector extends InjectedConnector {
  constructor({
    chains,
    options: options_
  } = {}) {
    super({
      chains,
      options: {
        name: ConnectorName.METAMASK,
        shimDisconnect: true,
        shimChainChangedDisconnect: true,
        ...options_
      }
    });

    _defineProperty(this, "id", 'MetaMask');

    _defineProperty(this, "ready", typeof window != 'undefined' && !!this.findProvider(window.ethereum));

    _provider.set(this, {
      writable: true,
      value: void 0
    });
  }

  async connect({
    chainId
  } = {}) {
    try {
      const provider = await this.getProvider();
      if (!provider) throw new ConnectorNotFoundError();

      if (provider.on) {
        provider.on('accountsChanged', this.onAccountsChanged);
        provider.on('chainChanged', this.onChainChanged);
        provider.on('disconnect', this.onDisconnect);
      }

      this.emit('message', {
        type: 'connecting'
      });
      const account = await this.getAccount(); // Switch to chain if provided

      let id = await this.getChainId();
      let unsupported = this.isChainUnsupported(id);

      if (chainId && id !== chainId) {
        const chain = await this.switchChain(chainId);
        id = chain.id;
        unsupported = this.isChainUnsupported(id);
      }

      return {
        account,
        chain: {
          id,
          unsupported
        },
        provider
      };
    } catch (error) {
      if (this.isUserRejectedRequestError(error)) throw new UserRejectedRequestError(error);
      if (error.code === RpcErrorCode.RESOURCE_UNAVAILABLE) throw new ResourceUnavailableError(error);
      throw error;
    }
  }

  async getProvider() {
    if (typeof window !== 'undefined') {
      _classPrivateFieldSet(this, _provider, this.findProvider(window.ethereum));
    }

    return _classPrivateFieldGet(this, _provider);
  }

  getReady(ethereum) {
    const isMetaMask = !!(ethereum !== null && ethereum !== void 0 && ethereum.isMetaMask);
    if (!isMetaMask) return undefined; // Brave tries to make itself look like MetaMask
    // Could also try RPC `web3_clientVersion` if following is unreliable

    return ethereum;
  }

  findProvider(ethereum) {
    if (ethereum !== null && ethereum !== void 0 && ethereum.providers) return ethereum.providers.find(this.getReady);
    return this.getReady(ethereum);
  }

}